module.exports = function() {
  return this.opts.filterByColumn?JSON.stringify(this.query):this.query;
}



// WEBPACK FOOTER //
// ./~/vue-tables-2/lib/computed/q.js